var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 mb-6"},[_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("$arrowBack")]),_c('span',{staticClass:"text-caption black--text ml-3",domProps:{"textContent":_vm._s('Retour arrière')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }